module.exports = __webpack_public_path__ + "static/img/banner02@2x.e0bea0c4.png";